"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = DropdownFilter;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react2 = require("@linaria/react");
var _dropdown = _interopRequireDefault(require("@ux/dropdown"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _motionFunctions = require("@site/pattern-library-core/motion-functions");
var _merchButton = require("@site/pattern-library-core/merch-button");
/**
 * Local Imports
 */

const FilterContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "FilterContainer",
  class: "pl-f1xu6lfa"
});
const ButtonContainer = /*#__PURE__*/(0, _react2.styled)("div")({
  name: "ButtonContainer",
  class: "pl-b1grw6kf"
});

/**
 * DropdownFilter Component.
 *
 * @param {Object} props React props
 * @param {Number} props.officeSelected Preset Location or Office
 * @param {Array} props.categorySelected Selected Deparment Array
 * @param {Array} props.remoteSelected Selected Remote Array
 * @param {Function} props.officeOnChange Forwarded onChange
 * @param {Function} props.categoryOnChange Forwarded onChange
 * @param {Function} props.remoteOnChange Forwarded onChange
 * @param {Array} props.location Array of Location ot Offices
 * @param {Array} props.category Array of Departments
 * @param {Array} props.remote Array of Remote
 * @param {String} props.locationLabel Label of Dropdown
 * @param {String} props.categorylabel Label of Dropdown
 * @param {String} props.remoteLabel Label of Dropdown
 * @param {Function} props.resetFilter Forwarded onClick
 * @param {String} props.resetButtonText Reset Button Text
 * @param {Object} props.dropdownProps Supported UXCore Dropdown props
 * @returns {React.ReactElement} DropdownFilter Component
 * @public
 */
function DropdownFilter({
  officeSelected,
  officeOnChange,
  location,
  locationLabel = 'Locations',
  categorySelected,
  categoryOnChange,
  category,
  categorylabel = 'Departments',
  remoteSelected,
  remoteOnChange,
  remote = 'Remote',
  remoteLabel = 'Remote Positions',
  resetFilter,
  resetButtonText = 'Reset',
  dropdownProps
}) {
  const {
    DropdownItem
  } = _dropdown.default;
  return /*#__PURE__*/_react.default.createElement(FilterContainer, {
    "data-cy": "dropdown-filter"
  }, /*#__PURE__*/_react.default.createElement(_dropdown.default, (0, _extends2.default)({
    id: "dropdown-first",
    type: "select",
    size: "large",
    name: "dropdown-first",
    label: locationLabel,
    placeholder: "Select",
    selected: officeSelected,
    onChange: officeOnChange
  }, dropdownProps), location?.map((item, i) => {
    return /*#__PURE__*/_react.default.createElement(DropdownItem, {
      key: i
    }, item.value);
  })), /*#__PURE__*/_react.default.createElement(_dropdown.default, (0, _extends2.default)({
    id: "dropdown-second",
    type: "select",
    name: "dropdown-second",
    label: categorylabel,
    placeholder: "Select",
    size: "large",
    selected: categorySelected,
    onChange: categoryOnChange
  }, dropdownProps), category?.map((item, i) => {
    return /*#__PURE__*/_react.default.createElement(DropdownItem, {
      key: i
    }, item.value);
  })), /*#__PURE__*/_react.default.createElement(_dropdown.default, (0, _extends2.default)({
    id: "dropdown-third",
    type: "select",
    name: "dropdown-third",
    label: remoteLabel,
    placeholder: "Select",
    size: "large",
    selected: remoteSelected,
    onChange: remoteOnChange
  }, dropdownProps), /*#__PURE__*/_react.default.createElement(DropdownItem, null, remote)), /*#__PURE__*/_react.default.createElement(ButtonContainer, null, /*#__PURE__*/_react.default.createElement(_merchButton.NSMerchButton, {
    "aria-label": "reset-button",
    text: resetButtonText,
    design: "primary",
    size: "small",
    onClick: resetFilter
  })));
}
DropdownFilter.propTypes = {
  location: _propTypes.default.array,
  category: _propTypes.default.array,
  remote: _propTypes.default.string,
  officeOnChange: _propTypes.default.func,
  categoryOnChange: _propTypes.default.func,
  remoteOnChange: _propTypes.default.func,
  officeSelected: _propTypes.default.number,
  categorySelected: _propTypes.default.array,
  remoteSelected: _propTypes.default.array,
  resetFilter: _propTypes.default.func,
  locationLabel: _propTypes.default.string,
  categorylabel: _propTypes.default.string,
  remoteLabel: _propTypes.default.string,
  resetButtonText: _propTypes.default.string,
  dropdownProps: _propTypes.default.shape(_dropdown.default.propTypes)
};